import styled from "styled-components";
import {GamePlayPcHeaderBarSectionBaseBox} from "../../game-play-pc-header-bar-section-base.box";

export const GamePlayPcHeaderBarTopMiddleSectionBox = styled(GamePlayPcHeaderBarSectionBaseBox)`
    flex-direction: column;
    justify-content: flex-start;
    flex-basis: 0;
`